/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePresentPositionResponse
 */
export interface UpdatePresentPositionResponse {
    /**
     * 
     * @type {string}
     * @memberof UpdatePresentPositionResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePresentPositionResponse
     */
    message: string;
}

/**
 * Check if a given object implements the UpdatePresentPositionResponse interface.
 */
export function instanceOfUpdatePresentPositionResponse(value: object): value is UpdatePresentPositionResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UpdatePresentPositionResponseFromJSON(json: any): UpdatePresentPositionResponse {
    return UpdatePresentPositionResponseFromJSONTyped(json, false);
}

export function UpdatePresentPositionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePresentPositionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'message': json['message'],
    };
}

export function UpdatePresentPositionResponseToJSON(value?: UpdatePresentPositionResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'message': value['message'],
    };
}

